import React, { forwardRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { GridActionsCellItem } from "@mui/x-data-grid";
import * as Icons from "react-bootstrap-icons";
import MButton from "Utils/Helpers/MButton";
import MInfoShow from "Utils/Helpers/MInfoShow";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { useDispatch } from "react-redux";
import { enqueueSnackbar } from "notistack";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setRoadmapData } from "../../../../../Redux/slices/mngrSlice";
import { delete_roadmap } from "http/components/Roadmap";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DeleteRoadmapData({ cell, row }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  const setShowDialog = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const onDelete = async () => {
    if (!row.isParent || row.subCount === 0) {
      dispatch(HandleLoading(true));
      const response = await delete_roadmap(row.id);
      if (CheckApiStatus(response)) {
        dispatch(setRoadmapData(true));
        enqueueSnackbar("Delete Success", { variant: "success" });
      }
      setShow(false);
      dispatch(HandleLoading(false));
    }
  };

  return (
    <>
      <GridActionsCellItem
        icon={<Icons.Trash3 size={16} />}
        label="Delete"
        onClick={setShowDialog}
        className="btn-manager btn-delete"
      />
      {show && (
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={"xs"}
          onClose={handleClose}
          aria-describedby="alert-dialog-delete"
        >
          <DialogTitle>{`Delete (${row.title})`}</DialogTitle>
          <DialogContent>
            {show && (
              <>
                <p>Are you sure you want to delete the information?</p>
                <div className="m-delete-data">
                  {!row.isParent && (
                    <MInfoShow label={"Category"} data={row.parentName} />
                  )}
                  <MInfoShow label={"Title"} data={row.title} />
                  {!row.isParent && (
                    <>
                      <MInfoShow label={"Status"} data={row.status} />
                      <MInfoShow label={"value"} data={row.value} />
                    </>
                  )}
                  {row.isParent && (
                    <>
                      <MInfoShow label={"Sub-Category"} data={row.subCount} />
                      {row.subCount !== 0 && (
                        <div className="m-delete-data sub-delete-data">
                          {row.subCategory.map((i, index) => {
                            return (
                              <MInfoShow
                                label={`Sub-Category [${index + 1}]`}
                                data={i.title}
                              />
                            );
                          })}
                          <span className="text-danger">
                            To delete the <u>Category</u>, you must first delete
                            the <u>Sub-Categories</u>
                          </span>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </DialogContent>
          <DialogActions>
            <MButton
              label={"Close"}
              color="secondary"
              onClick={handleClose}
              className="flex-grow-1"
            />
            <MButton
              label={"Delete"}
              color="danger"
              className="flex-grow-1"
              onClick={onDelete}
              disabled={row.isParent && row.subCount !== 0}
            />
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
